import { createContext, FC, useContext, useMemo, useState } from 'react';

import { UnsavedChangesModalProps } from '@shared/modals/unsaved-changes-modal';

export interface UnsavedChangesConfig
  extends Pick<UnsavedChangesModalProps, 'content' | 'labelCancel' | 'labelConfirm'> {
  hasChanges: boolean;
}

export interface UseOverlayResult {
  confirmOpen: boolean;
  unsavedChanges?: UnsavedChangesConfig;
  onCheckAndClose: () => void;
  onClose: () => void;
  setConfirmOpen: (open: boolean) => void;
}
/**
 * @deprecated Use UseOverlayResult instead
 */
export type ModalResult = UseOverlayResult;

const OverlayContext = createContext<UseOverlayResult>({} as UseOverlayResult);

export const useOverlay = () => {
  return useContext(OverlayContext);
};
/**
 * @deprecated Use useOverlay instead
 */
export const useModal = useOverlay;

interface OverlayProviderProps {
  unsavedChanges?: UnsavedChangesConfig;
  onClose: () => void;
}

export const OverlayProvider: FC<OverlayProviderProps> = ({ children, unsavedChanges, onClose }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const contextValue = useMemo(() => {
    const result: UseOverlayResult = {
      confirmOpen,
      unsavedChanges,
      onCheckAndClose: () => {
        if (unsavedChanges?.hasChanges) {
          setConfirmOpen(true);
          return;
        }

        onClose();
      },
      onClose,
      setConfirmOpen,
    };

    return result;
  }, [confirmOpen, unsavedChanges]);

  return <OverlayContext.Provider value={contextValue}>{children}</OverlayContext.Provider>;
};
/**
 * @deprecated Use OverlayProvider instead
 */
export const ModalProvider = OverlayProvider;
